// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"57":"2639a9b5","226":"e721f3f3","227":"cdd8b568","312":"404f1b7c","420":"e3e25edc","438":"ae8686dd","520":"871d9cc1","542":"1f7df3cb","682":"4918c16f"}[chunkId] + ".chunk.css";
};